import DashboardFilters from './DashboardFilters';

const Homepage = () => {
    return (
        <div className="dark:text-white">
            <DashboardFilters />
        </div>
    );
};

export default Homepage;
